import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator';
import AdvProductListCornerMark from '@/components/adv-components/adv-product-list-corner-mark';


import style from './index.module.scss';

export enum ButtonTypeEnum {
  credit,
  apply,
  newApply
}

export enum ButtonStatusEnum {
  countDown,
  avaliable,
}

export const buttonStatus = {
  [ButtonStatusEnum.countDown]: 'countdownNotClick',
  [ButtonStatusEnum.avaliable]: 'canClick',
};


export const forceReadButtonText = {
  [ButtonTypeEnum.credit]: '同意协议',
  [ButtonTypeEnum.apply]: { default: '同意协议，确认提现', insure: '同意协议，提现并投保' },
  [ButtonTypeEnum.newApply]: '同意协议，确认提现',
};


@Component({ name: 'ForceReadBtn' })
export default class ForceReadBtn extends Vue {
    @Prop(Object) readonly buttonType!: ButtonTypeEnum;

    @Prop(Object) readonly showScrollBottom!: boolean;

    @Prop(Object) readonly needCountDownNum!: boolean;

    /** 超级会员授信流程文案 */
    @Prop({
      type: String,
      default: '',
    })
    private readonly buttonText!: string;

    /** 是否需要投保（翼支付 & 众安） */
    @Prop({
      type: Boolean,
      default: false,
    })
    private readonly insure!: boolean;

    /**  按钮浮标id */
    @Prop(String)
    private advMasterId!: string;

    private countNum = 5;

    private countDownNum = 0;

    private btnStatus:ButtonStatusEnum = ButtonStatusEnum.avaliable;

    private timer: NodeJS.Timer | undefined = undefined;

    private btnTextComputed = '';

    private scrollToBottomText = '阅读全部协议'

    private setStatus() {
      let btnText = '';
      if (this.buttonType === ButtonTypeEnum.apply) {
        btnText = this.insure
          ? forceReadButtonText[this.buttonType].insure
          : forceReadButtonText[this.buttonType].default;
      } else if (this.buttonType === ButtonTypeEnum.credit && this.buttonText !== '') {
        btnText = this.buttonText;
      } else {
        btnText = forceReadButtonText[this.buttonType];
      }

      if (this.countDownNum) {
        if (this.showScrollBottom) {
          this.btnTextComputed = `${this.scrollToBottomText}（${this.countDownNum}s）`;
        } else {
          this.btnTextComputed = `${btnText}（${this.countDownNum}s）`;
        }
      } else {
        if (this.showScrollBottom) {
          this.btnTextComputed = this.scrollToBottomText;
        } else {
          this.btnTextComputed = btnText;
        }
      }
    }

    private countDown() {
      if (!this.timer) {
        this.countDownNum = this.countNum;
        this.btnStatus = ButtonStatusEnum.countDown;
        // eslint-disable-next-line consistent-return
        this.timer = setInterval(() => {
          if (this.countDownNum > 0 && this.countDownNum <= this.countNum) {
            this.countDownNum--;
            this.setStatus();
            if (this.countDownNum === 0) {
              if (this.timer) clearInterval(this.timer);
              this.btnStatus = ButtonStatusEnum.avaliable;
              this.timer = undefined;
            }
          }
        }, 1000);
      }
    }

    @Watch('needCountDownNum', { immediate: true })
    private watchNeedCountDownNum(val: boolean) {
      if (val) {
        this.countDown();
      }
    }

    // 监听超级会员文案变化
    @Watch('buttonText')
    private watchSuperMemberText() {
      this.setStatus();
    }

    // 监听申请滑动底部情况
    @Watch('showScrollBottom')
    private watchShowScrollBottom() {
      this.setStatus();
    }

    private created() {
      this.setStatus();
      this.$emit('exposeHandler');
    }

    private render() {
      return (
        <div class={[style.buttonWrapper,
          this.buttonType === ButtonTypeEnum.credit || this.buttonType === ButtonTypeEnum.newApply
            ? style.preApplyWrapper : '']}>
          <div class={[style.submitButton,
            this.btnStatus === ButtonStatusEnum.countDown
              ? style.unclickable : style.clickable,
            this.scrollToBottomText === (this.btnTextComputed.split('（'))[0] && style.scrollToBottom,
          ]}
            onClick={this.onSubmitClick.bind(this)}>
            {this.btnTextComputed}
            {this.advMasterId ? (
              <AdvProductListCornerMark advMasterId={this.advMasterId} />
            ) : null}
          </div>
        </div>
      );
    }

    // 点击事件
    private onSubmitClick() {
      if (this.btnStatus === ButtonStatusEnum.countDown) {
        this.$emit('countDown');
      } else if (this.showScrollBottom) {
        this.$emit('scrollToBottom');
      } else {
        this.$emit('submit');
      }
    }
}
